export interface Program {
  id: string;
  name: string;
  english: string;
  description: string;
  duration: string;
  image: string;
  benefits: string[];
  recommendedFor: string[];
  steps: string[];
}

export interface Testimonial {
  id: string;
  name: string;
  rating: number;
  text: string;
  tag: string;
}

export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const programs: Program[] = [
  {
    id: "pore",
    name: "모공·피지 집중관리",
    english: "Pore & Sebum Care",
    description: "모공 속 노폐물과 과잉 피지를 깨끗하게 정리하고, 모공을 조여 매끈한 피부결을 되찾아드립니다.",
    duration: "60분",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20artistic%20skincare%20concept%20of%20clear%20radiant%20smooth%20skin%20texture%20with%20gentle%20cleansing%20foam%20bubbles%20in%20soft%20dusty%20pink%20and%20white%20tones%20minimalist%20beauty%20product%20photography%20clean%20bright%20studio%20background%20delicate%20water%20droplets%20fresh%20pure%20aesthetic&width=600&height=750&seq=bianca-program-pore&orientation=portrait",
    benefits: [
      "모공 속 노폐물과 과잉 피지 제거",
      "모공 크기 개선과 타이트닝",
      "번들거림 완화와 유수분 밸런스",
      "매끈하고 맑은 피부결 완성",
    ],
    recommendedFor: [
      "모공이 넓어 고민인 분",
      "피지 분비가 많아 번들거리는 분",
      "블랙헤드와 화이트헤드로 고민인 분",
    ],
    steps: ["딥 클렌징", "스팀 & 모공 열기", "피지 정리 케어", "수렴 & 진정 마무리"],
  },
  {
    id: "hydration",
    name: "수분광",
    english: "Deep Hydration",
    description: "피부 속부터 차오르는 수분 충전으로, 촉촉하고 투명한 광채 피부를 완성해드립니다.",
    duration: "60분",
    image: "https://readdy.ai/api/search-image?query=Artistic%20skincare%20concept%20of%20dewy%20hydrated%20glowing%20skin%20with%20water%20droplets%20and%20moisture%20serum%20soft%20pink%20and%20cool%20light%20blue%20tones%20minimalist%20clean%20beauty%20photography%20bright%20airy%20background%20fresh%20luminous%20refreshing%20aesthetic&width=600&height=750&seq=bianca-program-hydration&orientation=portrait",
    benefits: [
      "피부 속 깊은 수분 충전",
      "당김과 건조함 완화",
      "광채 있는 촉촉한 피부 연출",
      "메이크업 밀착력 향상",
    ],
    recommendedFor: [
      "피부가 건조하고 당기는 분",
      "수분 부족으로 칙칙해진 분",
      "각질이 자주 일어나는 분",
    ],
    steps: ["수분 부스터 도입", "수분 마스크 케어", "보습 장벽 강화", "광채 마무리"],
  },
  {
    id: "soothing",
    name: "트러블 진정",
    english: "Trouble Soothing",
    description: "민감하고 예민해진 피부를 진정시키고, 트러블 자극을 완화해 편안한 피부로 가꿔드립니다.",
    duration: "70분",
    image: "https://readdy.ai/api/search-image?query=Soothing%20skincare%20concept%20of%20calm%20clear%20skin%20with%20gentle%20green%20botanical%20leaves%20and%20chamomile%20flowers%20soft%20mint%20green%20and%20cream%20tones%20minimalist%20clean%20beauty%20photography%20serene%20bright%20background%20healing%20calming%20aesthetic&width=600&height=750&seq=bianca-program-soothing&orientation=portrait",
    benefits: [
      "붉어지고 예민한 피부 진정",
      "트러블 자극 완화",
      "피부 장벽 회복 지원",
      "편안하고 안정된 피부 상태",
    ],
    recommendedFor: [
      "반복되는 트러블로 고민인 분",
      "민감하고 붉어지기 쉬운 분",
      "시술 후 피부 진정이 필요한 분",
    ],
    steps: ["저자극 클렌징", "진정 케어", "장벽 강화", "보습 마무리"],
  },
  {
    id: "brightening",
    name: "브라이트닝",
    english: "Brightening",
    description: "칙칙하고 어두워진 피부톤을 맑게 정돈해, 환하고 균일한 화사한 피부로 되살려드립니다.",
    duration: "60분",
    image: "https://readdy.ai/api/search-image?query=Radiant%20brightening%20skincare%20concept%20of%20luminous%20glowing%20skin%20with%20soft%20pearl%20and%20champagne%20highlights%20warm%20cream%20and%20dusty%20pink%20tones%20minimalist%20beauty%20photography%20bright%20elegant%20background%20luxurious%20illuminating%20aesthetic&width=600&height=750&seq=bianca-program-brightening&orientation=portrait",
    benefits: [
      "칙칙한 피부톤 맑게 정돈",
      "균일하고 화사한 피부 표현",
      "피부결 투명감 향상",
      "생기 있는 안색 완성",
    ],
    recommendedFor: [
      "피부톤이 칙칙하고 어두운 분",
      "자외선·생활로 얼룩진 피부",
      "화사한 메이크업 베이스를 원하는 분",
    ],
    steps: ["각질 정돈", "브라이트닝 케어", "톤 정돈 마스크", "광채 마무리"],
  },
  {
    id: "cleansing",
    name: "팁클렌징",
    english: "Deep Cleansing",
    description: "피부 깊숙한 곳까지 꼼꼼하게 클렌징하여, 막힘 없이 숨 쉬는 깨끗한 피부를 만들어드립니다.",
    duration: "50분",
    image: "https://readdy.ai/api/search-image?query=Gentle%20cleansing%20skincare%20concept%20with%20soft%20cotton%20pads%20and%20cleansing%20water%20delicate%20white%20and%20blush%20pink%20tones%20minimalist%20clean%20beauty%20photography%20bright%20serene%20background%20fresh%20pure%20hygienic%20aesthetic&width=600&height=750&seq=bianca-program-cleansing&orientation=portrait",
    benefits: [
      "피부 깊숙한 노폐물 제거",
      "모공 막힘 예방",
      "후속 케어 흡수력 향상",
      "가볍고 깨끗한 피부 완성",
    ],
    recommendedFor: [
      "메이크업 잔여물이 걱정되는 분",
      "모공이 자주 막히는 분",
      "관리 전 베이스 정리가 필요한 분",
    ],
    steps: ["1차 메이크업 클렌징", "2차 딥 클렌징", "스팀 케어", "보습 마무리"],
  },
  {
    id: "lifting",
    name: "탄력 리프팅",
    english: "Firming Lifting",
    description: "처지고 힘을 잃은 피부에 탄력을 되돌려, 도톰하고 탱글한 동안 피부로 관리해드립니다.",
    duration: "70분",
    image: "https://readdy.ai/api/search-image?query=Firming%20lifting%20skincare%20concept%20of%20sculpted%20youthful%20skin%20with%20gentle%20facial%20massage%20tool%20and%20silk%20ribbon%20soft%20rose%20pink%20and%20warm%20neutral%20tones%20minimalist%20beauty%20photography%20elegant%20bright%20background%20refined%20anti%20aging%20aesthetic&width=600&height=750&seq=bianca-program-lifting&orientation=portrait",
    benefits: [
      "처진 피부 탄력 회복",
      "얼굴 라인 정돈",
      "도톰하고 탱글한 피부",
      "동안 피부로의 변화",
    ],
    recommendedFor: [
      "피부 탄력이 떨어진 분",
      "얼굴 라인이 무너진 분",
      "노화 관리가 필요한 분",
    ],
    steps: ["딥 클렌징", "리프팅 케어", "경락 마사지", "탄력 마무리"],
  },
];

export const testimonials: Testimonial[] = [
  {
    id: "t1",
    name: "김수연",
    rating: 5,
    text: "모공이 고민이라 방문했는데, 3번 관리받고 피부결이 확실히 매끈해졌어요. 관리사 선생님께서 제 피부 상태를 꼼꼼히 봐주시고 맞춤으로 관리해주셔서 정말 만족스럽습니다.",
    tag: "모공·피지 관리",
  },
  {
    id: "t2",
    name: "이지현",
    rating: 5,
    text: "수분광 관리 받고 피부가 정말 촉촉해졌어요. 시술 직후부터 광이 나서 주변에서 피부 좋아졌다고 하더라고요. 분위기도 편안해서 관리받는 시간이 힐링 그 자체였어요.",
    tag: "수분광",
  },
  {
    id: "t3",
    name: "박민지",
    rating: 5,
    text: "예민한 피부라 피부과도 조심스러웠는데, 트러블 진정 프로그램으로 편안하게 관리받았습니다. 자극 없이 진정되는 느낌이었고, 다음 예약까지 바로 잡았어요.",
    tag: "트러블 진정",
  },
  {
    id: "t4",
    name: "최유나",
    rating: 5,
    text: "탄력 리프팅 관리 후 얼굴 라인이 살아난 게 느껴져요. 꼼꼼한 설명과 함께 관리해주셔서 믿고 맡길 수 있었습니다. 강력 추천합니다!",
    tag: "탄력 리프팅",
  },
];

export const faqs: Faq[] = [
  {
    id: "f1",
    question: "첫 방문 시 어떤 절차로 진행되나요?",
    answer: "첫 방문 시 피부 진단을 통해 현재 피부 상태를 정확히 파악한 뒤, 고객님의 고민과 목표에 맞는 맞춤 프로그램을 추천해드립니다. 상담은 무료로 진행되며 부담 없이 예약해주세요.",
  },
  {
    id: "f2",
    question: "관리 시간은 얼마나 소요되나요?",
    answer: "프로그램에 따라 50분에서 70분 정도 소요됩니다. 첫 방문의 경우 피부 진단과 상담 시간이 추가되어 약 20분 정도 더 소요될 수 있습니다.",
  },
  {
    id: "f3",
    question: "임신 중에도 관리를 받을 수 있나요?",
    answer: "임산부도 받으실 수 있는 순한 프로그램이 있습니다. 다만 개인 상태에 따라 제한될 수 있으니, 예약 시 미리 말씀해주시면 안전하게 진행할 수 있도록 안내해드립니다.",
  },
  {
    id: "f4",
    question: "예약 변경이나 취소는 어떻게 하나요?",
    answer: "예약 시간 24시간 전까지 전화 또는 카카오톡으로 변경·취소가 가능합니다. 당일 취소는 노쇼(No-show)로 간주될 수 있으니 양해 부탁드립니다.",
  },
  {
    id: "f5",
    question: "민감성 피부도 관리가 가능한가요?",
    answer: "네, 가능합니다. 민감성 피부를 위한 저자극 프로그램을 별도로 준비하고 있으며, 피부 진단 후 자극이 적은 성분과 방식으로 세심하게 관리해드립니다.",
  },
];